import Button from '@components/std-components/Button'
import Icon from '@components/std-components/Icons'
import { ArrowDropDown } from '@components/std-components/resources'
import classNames from 'classnames'
import React, { FC } from 'react'
import * as css from './DropdownTitle.css'
import { CentricTypography as Typography } from '@core/component/CentricTypography'

const DropdownTitle: FC<{ title; disabled; selected; showIcon? }> = ({
  title,
  disabled,
  selected,
  showIcon
}) => {
  return (
    <Button variant='icon' theme='light' size='none' disabled={disabled}>
      <div className={classNames(css['dropDownTitleContainer'])}>
        <div className={css['dropDownTitle']}>
          <Typography variant={'captionDarkGrey'}>
            {Boolean(selected?.length) ? selected[0] : title}
          </Typography>
        </div>
        {showIcon && <Icon imageSrc={ArrowDropDown} alt='select' />}
      </div>
    </Button>
  )
}

export default DropdownTitle
